export default __webpack_public_path__ + "static/media/signup-img-blue.75c396b9.png";